module.exports = __webpack_public_path__ + "static/media/hot.8f7aef36.svg";